import React, { ChangeEvent, ReactNode } from 'react';
import { CSSProperties } from 'styled-components';
import { Close } from 'components';
import {
  Input as InputStyled,
  Label,
  ErrorMessage,
  Icon,
  Clear,
} from './InputStyled';

type Props = {
  label?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
  name?: string;
  style?: CSSProperties;
  type?: string;
  value?: string;
  error?: boolean;
  errorMessage?: string;
  size?: 'sm' | 'md' | 'lg';
  icon: ReactNode;
  clear: boolean;
  onInput?: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
};

export const Input: any = React.forwardRef<HTMLInputElement, Props>(
  (props, ref) => {
    const {
      label,
      required = false,
      size = 'md',
      error = false,
      errorMessage,
      icon,
      type = 'text',
      clear = false,
      placeholder,
      onInput,
      onClear,
      ...rest
    } = props;

    return (
      <InputStyled
        size={size}
        error={error || errorMessage ? true : false}
        clear={clear}
        icon={!!icon}
      >
        {label && (
          <Label>
            {required && <span>*</span>}
            {label}
          </Label>
        )}
        {icon && <Icon>{icon}</Icon>}
        <input
          placeholder={placeholder}
          type={type}
          required={required}
          onInput={onInput}
          {...rest}
          ref={ref}
          autoFocus={false}
        />
        {clear && (
          <Clear onClick={onClear}>
            <Close fill='#949494' />
          </Clear>
        )}
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </InputStyled>
    );
  }
);
